export const calculateSceneCenter = (
  width: number,
  height: number,
  scrollX: number,
  scrollY: number,
  zoom: number,
) => {
  return {
    centerX: (width / 2 - scrollX) / zoom,
    centerY: (height / 2 - scrollY) / zoom,
  };
};

export const calculateScrollForCenter = (
  width: number,
  height: number,
  centerX: number,
  centerY: number,
  zoom: number,
) => {
  return {
    scrollX: width / 2 - centerX * zoom,
    scrollY: height / 2 - centerY * zoom,
  };
};
